import { toPublicMediaUrl } from '@/utils/publicMediaUrl'

const DISPLAY_ORIGIN = 'https://www.yuyuankj.cn'
const INTERNAL_ORIGINS = ['http://47.108.72.27:81', 'https://47.108.72.27:81']

function toDisplayUrl(value) {
  if (!value || typeof value !== 'string') return ''
  if (value.startsWith('asset://') || value.startsWith('blob:') || value.startsWith('data:')) return value
  const cdnValue = toPublicMediaUrl(value)
  if (cdnValue !== value) return cdnValue
  for (const origin of INTERNAL_ORIGINS) {
    if (value.startsWith(`${origin}/`)) return `${DISPLAY_ORIGIN}${value.slice(origin.length)}`
  }
  return value
}

// Keep the public HTTPS address in the editor/history. Older records may only
// contain the provider-facing IP address, so normalize that address on read.
export function referenceDisplayUrl(reference) {
  if (!reference) return ''
  if (typeof reference === 'string') return toDisplayUrl(reference)
  if (reference.url?.startsWith('asset://')) return reference.url
  return toDisplayUrl(reference.displayUrl || reference.display_url || reference.url || reference.sourceUrl || reference.source_url || reference.mediaUrl || reference.media_url || reference.localUrl || reference.assetUri || '')
}

export function parseReferenceFiles(raw) {
  if (!raw) return null
  let parsed = raw
  for (let i = 0; i < 2 && typeof parsed === 'string'; i += 1) {
    try { parsed = JSON.parse(parsed) } catch (_) { return null }
  }
  if (!parsed || typeof parsed !== 'object') return null
  // Some older responses wrap the actual media object in `data` or `references`.
  if (!Array.isArray(parsed.images) && !Array.isArray(parsed.videos) && !Array.isArray(parsed.audios)) {
    parsed = parsed.data || parsed.references || parsed.referenceFiles || parsed
  }
  if (typeof parsed === 'string') {
    try { parsed = JSON.parse(parsed) } catch (_) { return null }
  }
  if (!parsed || typeof parsed !== 'object') return null
  if (Array.isArray(parsed)) parsed = { images: parsed }
  return {
    ...parsed,
    images: Array.isArray(parsed.images) ? parsed.images.map(referenceForDisplay) : [],
    videos: Array.isArray(parsed.videos) ? parsed.videos.map(referenceForDisplay) : [],
    audios: Array.isArray(parsed.audios) ? parsed.audios.map(referenceForDisplay) : []
  }
}

export function referenceForDisplay(reference) {
  if (typeof reference === 'string') return { url: referenceDisplayUrl(reference) }
  return { ...reference, url: referenceDisplayUrl(reference) }
}
